/**
 * * Classe de Alertas.
 */
export class Alert {
  constructor(
    /**
     * * Tipo do alerta.
     */
    public type: AlertType,
    /**
     * * Título do alerta.
     */
    public title: string,
    /**
     * * Mensagem do Alerta.
     */
    public message: string
  ) {}
}

/**
 * * Enum dos tipos de alerta.
 */
export enum AlertType {

  /**
   * * Alerta de Sucesso.
   */
  Success,
  /**
   * * Alerta de Erro.
   */
  Error,
  /**
   * * Alerta de informação.
   */
  Info,
  /**
   * * Alerta de aviso.
   */
  Warning
}

